export enum PartnerAliasEnum {
	Zesty = 'cloudvisor',
	TwoBCloud = 'twobcloud',
	ZestySandbox = 'zestysandbox',
}
